module.exports = __webpack_public_path__ + "9b5693471fb99caac3649208cec94e1c.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/hat-painter.png
// module id = 2733
// module chunks = 0